import i18next from "i18next";
import { EN_ACCEPT_LANGUAGE } from "../constants/acceptLanguageApi";

export const getLanguageLabel = (en: string, la: string) => {
    return i18next.language === EN_ACCEPT_LANGUAGE ? en : la;
};